import { BudgetsUiAlertsActions } from "../_actions/BudgetsUiAlertsActions";
import { GenericErrorWrapperFactory } from "../../Common/_generics/GenericErrorWrapperFactory";

export const genericActions = GenericErrorWrapperFactory(BudgetsUiAlertsActions.showErrorAlert);